/* eslint-disable no-restricted-syntax -- amber token for warning, theme has no warning colour */
import { useTranslation } from 'react-i18next';
import { AlertTriangle, ShieldCheck } from 'lucide-react';
import { useThemeContext } from '@utils/providers/theme-context.tsx';
import type { PlatformSpec } from '@utils/types/connections/platforms.ts';

const WARNING_ICON = '#B45309';

interface Props {
  platform: PlatformSpec;
}

export default function StepPermissions({ platform }: Props) {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();

  return (
    <div className="flex flex-col gap-4">
      <div
        className="flex items-start gap-3 rounded-xl border p-4"
        style={{
          borderColor: getColour('hairline'),
          background: getColour('secondLayer')
        }}
      >
        <ShieldCheck
          className="h-5 w-5 shrink-0"
          aria-hidden="true"
          style={{ color: getColour('activeText') }}
        />
        <div className="flex flex-col gap-1">
          <p className="text-sm font-semibold">
            {t('publishing-wizard-permissions-what-title', {
              platform: platform.displayName
            })}
          </p>
          <p
            className="text-sm whitespace-pre-line"
            style={{ color: getColour('normalText') }}
          >
            {t(platform.permissionCopyKey)}
          </p>
        </div>
      </div>

      {platform.oauthWarningKey && (
        <div
          role="note"
          className="flex items-start gap-3 rounded-xl border p-4"
          style={{
            borderColor: getColour('hairline'),
            background: getColour('thirdLayer')
          }}
        >
          <AlertTriangle
            className="h-5 w-5 shrink-0"
            aria-hidden="true"
            style={{ color: WARNING_ICON }}
          />
          <div className="flex flex-col gap-1">
            <p className="text-sm font-semibold">
              {t('publishing-wizard-permissions-google-warning-title')}
            </p>
            <p className="text-sm" style={{ color: getColour('normalText') }}>
              {t(platform.oauthWarningKey)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
